import styled from 'styled-components';
import { grey } from '../../global/colours';

export const StyledDivider = styled.hr`
  border: none;
  border-top: 1px solid ${grey[200]};
  margin: 30px 0;
`;

export default StyledDivider;
